import Screen from "../components/Screen";
import { PrimaryBtn } from "../components/Buttons";
import Notice from "../components/Notice";
import Ico, { infoIcon } from "../components/Ico";
import { useSupplier } from "../SupplierContext";

interface AdKnownProps {
  onNext: () => void;
}

type IconName = Parameters<typeof Ico>[0]["name"];

const AdKnown = ({ onNext }: AdKnownProps) => {
  const supplier = useSupplier();
  // 只顯示後端真的給的欄位：地址／電話任一為空就整列不出現，
  // 避免像先前那樣印出寫死的 demo 地址，讓客戶看到別家瓦斯行的地址。
  type MetaRow = [icon: IconName, key: string, value: string, full?: boolean];
  const meta: MetaRow[] = [];
  if (supplier.address) meta.push(["pin", "地址", supplier.address, true]);
  if (supplier.phone) meta.push(["phone", "聯絡電話", supplier.phone]);
  const perks: Array<[icon: IconName, title: string, desc: string]> = [
    ["mobile", "一鍵訂購", "App 直接叫瓦斯、追蹤進度"],
    ["bell", "貼心提醒", "瓦斯快用完主動通知您"],
    ["receipt", "電子發票", "線上付款、自動開立發票"],
  ];
  return (
    <Screen
      title="歡迎加入"
      subtitle="此傳單已為您帶入指定的合作瓦斯行"
      footer={<PrimaryBtn onClick={onNext}>開始註冊</PrimaryBtn>}
    >
      {/* 瓦斯行資訊卡 */}
      <div className="bg-[#F8FAFC] border border-[#EEF1F5] rounded-[16px] px-[18px] py-4">
        <div className="flex items-center gap-[14px]">
          <div className="w-[52px] h-[52px] rounded-[14px] bg-[#2196f3] flex items-center justify-center shrink-0">
            <Ico name="store" c="#fff" s={26} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              <span className="text-[17px] font-extrabold text-[#1565C0]">{supplier.name}</span>
              <span className="bg-[#DCFCE7] text-[#15803D] text-[10px] font-bold px-2 py-[3px] rounded-[20px]">已指定</span>
            </div>
            <div className="text-xs text-[#94A3B8] mt-[3px]">合作瓦斯行</div>
          </div>
        </div>
        {/* 一個欄位都沒有時連分隔線一起收掉，免得卡片下半留一條線加空白 */}
        {meta.length > 0 && <div className="h-px bg-[#EEF1F5] my-[14px]" />}
        <div className="grid grid-cols-2 gap-x-2.5 gap-y-[14px]">
          {meta.map(([e, k, v, full]) => (
            <div key={k} style={{ gridColumn: full ? "1 / -1" : "auto" }}>
              <div className="text-[11px] text-[#94A3B8] flex items-center gap-1">
                <Ico name={e} c="#94A3B8" s={13} />
                {k}
              </div>
              <div className="text-[13px] font-semibold text-[#333] mt-[3px]">{v}</div>
            </div>
          ))}
        </div>
      </div>

      {/* 加入後即可享有 */}
      <div className="mt-[22px]">
        <div className="text-[15px] font-extrabold text-[#222] mb-[14px]">加入後即可享有</div>
        <div className="flex flex-col gap-[14px]">
          {perks.map(([e, t, d]) => (
            <div key={t} className="flex items-center gap-3">
              <div className="w-[42px] h-[42px] rounded-[12px] bg-[#EFF6FF] flex items-center justify-center shrink-0">
                <Ico name={e} c="#2196f3" s={22} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-bold text-[#333]">{t}</div>
                <div className="text-xs text-[#94A3B8] mt-px">{d}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-5">
        <Notice tone="blue" icon={infoIcon}>
          將以新客戶身份為您註冊並綁定 {supplier.name}，完成後即可開始訂購。
        </Notice>
      </div>
    </Screen>
  );
};

export default AdKnown;
